import styled from "styled-components"

export const AllCoursesStyles = styled.div`
  padding-bottom: 50px;
  max-width: 1536px;
  margin-left: auto;
  margin-right: auto;

  .kursus-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .kursus-list > * {
    width: calc(250px + 5%);
  }

  @media only screen and (max-width: 767.98px) {
    .kursus-list > * {
      width: calc(90%);
    }
  }
`

export const ModalStyle = styled.div`
  .kursus-detail {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 30px;

    .image {
      width: 30%;
    }

    .title-utama {
      text-align: left;
      font-size: 18px;
      font-weight: bold;
    }

    .nama-tutor {
      padding-top: 5px;
      font-size: 15px;
      font-weight: normal;
    }
  }

  .rating {
    display: flex;
    justify-content: center;
    margin: 20px auto;
  }

  .pendapat {
    text-align: left;
    font-weight: 600;
    font-size: 14px;

    .textArea {
      height: 80px;
    }
  }

  @media only screen and (max-width: 767.98px) {
    .kursus-detail {
      gap: 10px;
      .image {
        width: 40%;
        margin: auto;
      }
      .title-utama {
        text-align: left;
        font-size: 14px;
        font-weight: bold;
      }

      .nama-tutor {
        padding-top: 5px;
        font-size: 12px;
        font-weight: normal;
      }
    }
    .rating {
      display: flex;
      justify-content: center;
      margin: 10px auto;
    }

    .pendapat {
      text-align: left;
      font-weight: 600;
      font-size: 14px;

      .textArea {
        height: 80px;
      }
    }

    .submit {
      margin: 0px;
      padding: 5px 15px;
      font-size: 12px;
    }
  }
`
